export const mockUsers = [
    { "id": 1, name: "Lazar Lekic" },
    { "id": 2, name: "Test user" }
]